import React from "react";
import { connect } from "react-redux";
 
import RegisterModal from "./RegisterModal";
 import LoginModal from './LoginModal';
 import ImageZoomModal from './ImageZoomModal'; 
 
 import ShowVideoModal from './ShowVideoModal';

 import CreateImagesModal from './CreateImagesModal';
 
 import ShowImagesForEditModal from './ShowImagesForEditModal';
 
 import MessageModal from './MessageModal';

import TermsAndConditionsModal from './TermsAndConditionsModal'
import CookiesPolicyModal from './CookiesPolicyModal'
import PrivacyPolicyModal from './PrivacyPolicyModal'
import ContactUsModal from './ContactUsModal'
import CreateFormModal from './CreateFormModal'
import CreateFormWebModal from './CreateFormWebModal'
import SearchModal from './SearchModal'
import CreateFormNameModal from './CreateFormNameModal'
import ViewNameModal from './ViewNameModal'

const modalLookup = { 
   LoginModal,
   RegisterModal,
   ImageZoomModal,
   
   ShowVideoModal,

   CreateImagesModal,
   
   ShowImagesForEditModal,
   
   MessageModal,
  CookiesPolicyModal,
  PrivacyPolicyModal,
  TermsAndConditionsModal,
  ContactUsModal,

  CreateFormModal,
  CreateFormWebModal,

  SearchModal,
  CreateFormNameModal,
  ViewNameModal,
};

const mapState = state => ({
  currentModal: state.modals
});

const ModalManager = ({ currentModal }) => {
  let renderedModal;

  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modalLookup[modalType];

    renderedModal = <ModalComponent {...modalProps} />;
  }
  return <span>{renderedModal}</span>;
};

export default connect(mapState)(ModalManager);
